export default __webpack_public_path__ + "static/media/shawFlat.7bfdbb82.png";